import React, { Component } from 'react'
import './index.css'
import Address from '../AccountPage/Address'
import { Link } from 'react-router-dom'
import withRouter from '../../withRouter'
import serverInfo from '../../config'
import userInfo from '../../userInfo'
import PubSub from 'pubsub-js'
import PageRoute from '../PageRoute'
import { PayPalScriptProvider,PayPalButtons } from '@paypal/react-paypal-js'
import Paypal from '../Paypal'
import Cookies from 'universal-cookie'
import axios from 'axios'
import { nanoid } from 'nanoid'
class CheckOutPage extends Component {
    constructor(props){
        super(props)
        this.taxes = {
            Ontario:13,
            Quebec:14.975,
            'Nova Scotia':15,
            'New Brunswick':15,
            'Manitoba':12,
            'British Columbia':12,
            'Prince Edward Island':15,
            Saskatchewan:11,
            Alberta:5,
            'Newfoundland and Labrador':15,
            'Northwest Territories':5,
            Yukon:5,
            Nunavut:5,
        }
        this.province = {
            "Canada":['Ontario','Quebec','Nova Scotia','New Brunswick','Manitoba','British Columbia', 'Prince Edward Island', 'Saskatchewan', 'Alberta', 'Newfoundland and Labrador', 'Northwest Territories', 'Yukon', 'Nunavut'],
            "United States":['Alabama','Alaska','Arizona','Arkansas','California','Colorado','Connecticut','Delaware','Florida','Georgia','Hawaii','Idaho','Illinois','Indiana','Iowa','Kansas','Kentucky','Louisiana','Maine','Maryland','Massachusetts','Michigan','Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire','New Jersey','New Mexico','New York','North Carolina','North Dakota','Ohio','Oklahoma','Oregon','Pennsylvania','Rhode Island','South Carolina','South Dakota','Tennessee','Texas','Utah','Vermont','Virginia','Washington','West Virginia','Wisconsin','Wyoming']
        }
        this.taxIds = {
            Ontario:'4033264000000079415',
            Quebec:'4033264000000079439',
            'Nova Scotia':'4033264000000080605',
            'New Brunswick':'4033264000000080605',
            'Manitoba':'4033264000095432486',
            'British Columbia':'4033264000000079445',
            'Prince Edward Island':'4033264000000080605',
            Saskatchewan:'4033264000095432492',
            Alberta:'4033264000000079421',
            'Newfoundland and Labrador':'4033264000000080605',
            'Northwest Territories':'4033264000000079421',
            Yukon:'4033264000000079421',
            Nunavut:'4033264000000079421',
        }
        this.publicCustomers = {
            Ontario:'4033264000114382564',
            Quebec:'4033264000114382616',
            'Nova Scotia':'4033264000114382538',
            'New Brunswick':'4033264000114382486',
            'Manitoba':'4033264000114382460',
            'British Columbia':'4033264000114382434',
            'Prince Edward Island':'4033264000114382590',
            Saskatchewan:'4033264000114382642',
            Alberta:'4033264000114382408',
            'Newfoundland and Labrador':'4033264000114382512',
            'Northwest Territories':'4033264000114382356',
            Yukon:'4033264000114382382',
            Nunavut:'4033264000114382330',
        }
        this.cookies = new Cookies()
       // for paypal production  
        this.clientId = 'AeLDE55Tyh5D-c9bQI_qD036ZC7zLHhRxOfw1XdFybM9E2-TmYc41_SAP6H155WEMOPHJ4OFQInh9seJ'
        //for paypal sandbox
        // this.clientId = 'AbCGsXJBGzk7UNDFXq1X89h3zogUWdEeaqCkFaqTVKykSZezaMn9w3uTpfgvsrWUCEzzNtBjrbiyXwsX'
        // this.clientId = 'AcmXIf0pDcANDdO1yYskhxViHY-K9w3U0e_GLCA6I9OYVQ6U-fYwBeHJhbsvWcX9Qy7I4drfnaG7-fHV'
        this.state = {
            isSynced:false,
            cartItemsNumber:0,
            cartItemsSubtotal:0,
            addresses:[],
            tax: null,
            grandTotal:null,
            cartItemsWeight:0,
            shippingRate:0,
            shippingTax:0,
            shippingAddress:{},
            billingAddress:{},
            shippingRates:[],
            isSameAddress:false,
            chosenAddress:null,
            showShippingAddressForm:false,
            showBillingAddressForm:false,
            shippingAddressSelected:false,
            billingAddressSelected:false,
            shippingCountry:"Canada",
            shippingProvince:null,
            shippingZip:null,
            billingCountry: "Canada",
            billingZip:null,
            shippingMethod:null,
            email:serverInfo.email,
            confirmEmail:serverInfo.email,
            payment:'paypal',
            errors:{},
            uid:nanoid(20),
        }
        this.emailRef = React.createRef()
        this.confirmEmailRef = React.createRef()
        this.shippingAddressFirstNameRef = React.createRef()
        this.shippingAddressLastNameRef = React.createRef()
        this.shippingAddressCompanyRef = React.createRef()
        this.shippingAddressPhoneNumberRef = React.createRef()
        this.shippingAddressLine1Ref = React.createRef()
        this.shippingAddressLine2Ref = React.createRef()
        this.shippingAddressCityRef = React.createRef()
        this.shippingAddressCountryRef = React.createRef()
        this.shippingAddressProvinceRef = React.createRef()
        this.shippingAddressZipRef = React.createRef()
        this.billingAddressFirstNameRef = React.createRef()
        this.billingAddressLastNameRef = React.createRef()
        this.billingAddressCompanyRef = React.createRef()
        this.billingAddressPhoneNumberRef = React.createRef()
        this.billingAddressLine1Ref = React.createRef()
        this.billingAddressLine2Ref = React.createRef()
        this.billingAddressCityRef = React.createRef()
        this.billingAddressCountryRef = React.createRef()
        this.billingAddressProvinceRef = React.createRef()
        this.billingAddressZipRef = React.createRef()
    }
    isSameAddressHandler= ()=>{
        if(!this.state.isSameAddress){
            this.setState({
                isSameAddress: !this.state.isSameAddress,
                billingAddress: this.state.shippingAddress? {...this.state.shippingAddress} : this.state.shippingAddress
            })
        }else{
            this.setState({isSameAddress:!this.state.isSameAddress})
        }
    }
    fillAddress = (fieldName) =>{
        const shippingAddress = {
            first_name: this.shippingAddressFirstNameRef.current.value === '' ? null: this.shippingAddressFirstNameRef.current.value,
            last_name: this.shippingAddressLastNameRef.current.value === '' ? null: this.shippingAddressLastNameRef.current.value,
            company: this.shippingAddressCompanyRef.current.value === '' ? null: this.shippingAddressCompanyRef.current.value,
            phone_number: this.shippingAddressPhoneNumberRef.current.value === '' ? null: this.shippingAddressPhoneNumberRef.current.value,
            address_line_1: this.shippingAddressLine1Ref.current.value === '' ? null: this.shippingAddressLine1Ref.current.value,
            address_line_2: this.shippingAddressLine2Ref.current.value === '' ? '' :this.shippingAddressLine2Ref.current.value,
            city: this.shippingAddressCityRef.current.value === '' ? null: this.shippingAddressCityRef.current.value,
            province: this.shippingAddressProvinceRef.current.value === 'Choose a State' ? null : this.shippingAddressProvinceRef.current.value,
            country : this.shippingAddressCountryRef.current.value,
            zip: this.shippingAddressZipRef.current.value === '' ? null: this.shippingAddressZipRef.current.value.replace(/ /g,'')
        }
        const billingAddress = {
            first_name: this.billingAddressFirstNameRef.current.value === '' ? null : this.billingAddressFirstNameRef.current.value,
            last_name: this.billingAddressLastNameRef.current.value  === '' ? null : this.billingAddressLastNameRef.current.value,
            company: this.billingAddressCompanyRef.current.value === '' ?null: this.billingAddressCompanyRef.current.value,
            phone_number: this.billingAddressPhoneNumberRef.current.value  === '' ? null : this.billingAddressPhoneNumberRef.current.value,
            address_line_1: this.billingAddressLine1Ref.current.value  === '' ? null : this.billingAddressLine1Ref.current.value,
            address_line_2: this.billingAddressLine2Ref.current.value === '' ? '' :this.billingAddressLine2Ref.current.value,
            city: this.billingAddressCityRef.current.value  === '' ? null : this.billingAddressCityRef.current.value,
            province: this.billingAddressProvinceRef.current.value === 'Choose a State' ? null : this.billingAddressProvinceRef.current.value,
            country : this.billingAddressCountryRef.current.value,
            zip: this.billingAddressZipRef.current.value  === '' ? null : this.billingAddressZipRef.current.value.replace(/ /g,'')
        }
        this.setState({shippingAddress:{...shippingAddress},billingAddress:this.state.isSameAddress?shippingAddress:(this.state.showBillingAddressForm ? {...billingAddress} : this.state.billingAddress)})
        // console.log(shippingAddress,billingAddress)
        const zipRegex = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z]\d[ABCEGHJ-NPRSTV-Z]\d$/i
        // for getting shipping rates

        // if(shippingAddress.zip && zipRegex.exec(shippingAddress.zip) && this.state.shippingAddress.zip!==shippingAddress.zip){
        //     axios.post(`${serverInfo.baseURL}/shipping/rate`,{weight:this.state.cartItemsWeight,zip:shippingAddress.zip},{headers:{'customerid':serverInfo.customerid,'authorization':serverInfo.token}}).then(
        //         res=>{
        //             if(res.data.scode === 200){
        //                 this.calculateTax(shippingAddress,res.data.shippingRates)
        //                 this.setState({shippingAddress,billingAddress:this.state.isSameAddress?shippingAddress:billingAddress,shippingRates:[...res.data.shippingRates]})
        //                 // console.log(res.data)
        //             }else{
        //                 alert(res.data.smessage)
        //             }
        //             this.setState({smessage:res.data.smessage})
        //         },
        //         rej=>console.log(rej)
        //     )
        // }else{
        //     this.calculateTax(shippingAddress,this.state.shippingRates)
        // }
        
    }

    // for shipping rates taxes
    // calculateTax = (data,shippingRates) =>{
    //     // console.log('calculate Tax',data.country,data.province)
        
    //     let shippingTax = this.state.shippingTax, shippingRate = this.state.shippingRate
    //     if(data?.province){
    //         console.log(data?.zip,this.state.shippingAddress?.zip)
    //         if(this.state.shippingMethod && data?.zip !== this.state.shippingAddress.zip){
    //             const shippingService = this.state.shippingMethod.split(' - ')?.[1]
    //             for(const shippingRateObj of shippingRates){
    //                 // console.log(shippingRateObj['service-name'],shippingService)
    //                 if(shippingRateObj['service-name'] === shippingService){
    //                     shippingRate = shippingRateObj['price']
    //                     shippingTax = shippingRateObj['price'] * this.taxes[data.province] * 0.01
    //                 }
    //             }
    //         } 
    //         const tax =  this.state.cartItemsSubtotal * this.taxes[data.province] * 0.01 
    //         const grandTotal = this.state.cartItemsSubtotal + tax + this.state.shippingTax + this.state.shippingRate
    //         PubSub.publish('grandTotal',grandTotal)
    //         userInfo.updateInfo('grandTotal',grandTotal)
    //         this.setState({shippingAddress:{...data},billingAddress:this.state.isSameAddress?{...data}:this.state.billingAddress,tax,grandTotal,shippingTax,shippingRate})
    //     }else{
    //         PubSub.publish('grandTotal',0)
    //         userInfo.updateInfo('grandTotal',0)
    //         this.setState({shippingAddress:data,tax:null,billingAddress:this.state.isSameAddress?{...data}:this.state.billingAddress,grandTotal:null,shippingTax:0,shippingRate:0,shippingMethod:null})
    //     }
    // }
    calculateTax = (data,shippingRates) =>{
        // console.log('calculate Tax',data.country,data.province)
        
        let shippingTax = this.state.shippingTax, shippingRate = this.state.shippingRate
        if(data?.province){
            // console.log(data?.zip,this.state.shippingAddress?.zip)
            // if(this.state.shippingMethod && data?.zip !== this.state.shippingAddress.zip){
            //     const shippingService = this.state.shippingMethod.split(' - ')?.[1]
            //     for(const shippingRateObj of shippingRates){
            //         // console.log(shippingRateObj['service-name'],shippingService)
            //         if(shippingRateObj['service-name'] === shippingService){
            //             shippingRate = shippingRateObj['price']
            //             shippingTax = shippingRateObj['price'] * this.taxes[data.province] * 0.01
            //         }
            //     }
            // } 
            const tax =  this.state.cartItemsSubtotal * this.taxes[data.province] * 0.01 
            const grandTotal = this.state.cartItemsSubtotal + tax + this.state.shippingTax + this.state.shippingRate
            PubSub.publish('grandTotal',grandTotal)
            userInfo.updateInfo('grandTotal',grandTotal)
            this.setState({shippingAddress:{...data},billingAddress:this.state.isSameAddress?{...data}:this.state.billingAddress,tax,grandTotal,shippingTax,shippingRate})
        }else{
            PubSub.publish('grandTotal',0)
            userInfo.updateInfo('grandTotal',0)
            this.setState({shippingAddress:data,tax:null,billingAddress:this.state.isSameAddress?{...data}:this.state.billingAddress,grandTotal:null,shippingTax:0,shippingRate:0,shippingMethod:null})
        }
    }
    dataFormCheck = (value,isMandatory,maxLength) =>{
        if(isMandatory){
            return (!value || value === "" || value.length > maxLength) ? false : true
        }else{
            return (!value?.length || value?.length <= maxLength) ? true : false
        }
    }
    validateAddress = (shippingAddress,billingAddress,text) =>{
        const  emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/
        const zipRegex = {
            Canada:{
                shipping:/^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z]\d[ABCEGHJ-NPRSTV-Z]\d$/i,
                billing:/^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z]\d[ABCEGHJ-NPRSTV-Z]\d$/i
            },
            "United States":{
                shipping:/(^\d{5}$)|(^\d{5}-\d{4}$)/,
                billing:/(^\d{5}$)|(^\d{5}-\d{4}$)/
            }
        }
        const phoneRegex = {
            billing:/^\d{10}$/,
            shipping:/^\d{10}$/
        }
        const errors = {}
        let passCheck = true

        if(serverInfo.customerid ==='visitors'){
            if(emailRegex.exec(this.emailRef.current.value)){
                errors['email'] = null
            }else{
                errors['email'] = 'please check your email, the format is wrong.'
                passCheck = false
            }
            if(this.emailRef.current.value !== this.confirmEmailRef.current.value){
                errors['confirmEmail'] = 'Email and confirm email does not match.'
                passCheck = false
            }else{
                errors['confirmEmail'] = null
            }
        }else{
            errors['email'] = null
            errors['confirmEmail'] = null
        }
        errors['shippingAddressFirstName'] = this.dataFormCheck(shippingAddress.first_name,true,50) ? null : "First Name cannot be empty or exceed max length (50)."
        errors['shippingAddressLastName'] = this.dataFormCheck(shippingAddress.last_name,true,50) ? null : "Last Name cannot be empty or exceed max length (50)."
        errors['shippingAddressCompany'] = this.dataFormCheck(shippingAddress.company,false,50) ? null : "Exceed max length (50)."
        errors['shippingAddressLine1'] = this.dataFormCheck(shippingAddress.address_line_1,true,500) ? null : "Address Line 1 cannot be empty or exceed max length (500)."
        errors['shippingAddressLine2'] = this.dataFormCheck(shippingAddress.address_line_2,false,500) ? null : "Exceed max length (500)."
        errors['shippingAddressCity'] = this.dataFormCheck(shippingAddress.city,true,100) ? null : "City cannot be empty or exceed max length (100)."
        errors['shippingAddressProvince'] = shippingAddress.province ? null : "Please select province"
        errors['shippingAddressZip'] = zipRegex?.[shippingAddress.country]?.['shipping']?.exec(shippingAddress.zip) ? null : "Zip code error, Do not split zip code with space or any other chracter."
        errors['shippingAddressPhoneNumber'] = phoneRegex['shipping'].exec(shippingAddress.phone_number) ? null : "Phone Number error, Please only enter 10 digit Number."
        errors['billingAddressFirstName'] = this.dataFormCheck(billingAddress.first_name,true,50) ? null : "First Name cannot be empty or exceed max length (50)."
        errors['billingAddressLastName'] = this.dataFormCheck(billingAddress.last_name,true,50) ? null : "Last Name cannot be empty or exceed max length (50)."
        errors['billingAddressCompany'] = this.dataFormCheck(billingAddress.company,false,50) ? null : "Exceed max length (50)."
        errors['billingAddressLine1'] = this.dataFormCheck(billingAddress.address_line_1,true,500) ? null : "Address Line 1 cannot be empty or exceed max length (500)."
        errors['billingAddressLine2'] = this.dataFormCheck(billingAddress.address_line_2,false,500) ? null : "Exceed max length (500)."
        errors['billingAddressCity'] = this.dataFormCheck(billingAddress.city,true,100) ? null : "City cannot be empty or exceed max length (100)."
        errors['billingAddressProvince'] = billingAddress.province ? null : "Please select province"
        errors['billingAddressZip'] = zipRegex?.[billingAddress.country]?.["billing"].exec(billingAddress.zip) ? null : "Zip code error, Do not split zip code with space or any other chracter."
        errors['billingAddressPhoneNumber'] = phoneRegex["billing"].exec(billingAddress.phone_number) ? null : "Phone Number error, Please only enter 10 digit Number."
        for(const field in errors){
            if(errors[field]){
                passCheck = false
                break
            }
        }
        userInfo.updateInfo('addressValidation',passCheck)
        // this.setState({
        //     errors:{...errors}
        // })
        return {passCheck,errors}
    }
    placeOrder = (nonce) => {
        // if(this.state.billingAddress && this.state.shippingAddress && this.state.cartItemsNumber !== 0 && this.state.email){
            var tzoffset = (new Date()).getTimezoneOffset() * 60000;
            var localISOTime = (new Date(Date.now() - tzoffset)).toISOString();
            const lineItems = []
            for(const item of userInfo.cartItems){
                console.log(item.personal_price)
                lineItems.push({
                    item_id:item.item_id,
                    item_name:item.item_name,
                    quantity:item.quantity,
                    sku:item.sku,
                    item_rate:item.item_condition === "ScratchDent" ? item.personal_scratch_dent_price : (item.is_sale && item.personal_sale_price && item.personal_sale_price !==0 ? item.personal_sale_price : item.personal_price),
                    main_image:item.main_image,
                    item_condition:item.item_condition,
                    tax_id:this.taxIds[this.state.shippingAddress.province]
                })
            }
            const data = {
                orderInfo:{
                    customer_id:serverInfo.customerid === 'visitors' ? this.publicCustomers[this.state.shippingAddress.province] : serverInfo.customerid,
                    temporary_id: serverInfo.temporaryid,
                    shipping_address_id:this.state.shippingAddress.address_id ? this.state.shippingAddress.address_id:null,
                    billing_address_id:this.state.billingAddress.address_id ?this.state.billingAddress.address_id:null,
                    created_time:localISOTime,
                    line_items:lineItems,
                    subtotal:this.state.cartItemsSubtotal,
                    items_tax:this.state.tax,
                    shipping:this.state.shippingRate,
                    shipping_tax: this.state.shippingTax,
                    total:this.state.grandTotal,
                    email: this.state.email === '' ? this.emailRef.current.value : this.state.email,
                    shipping_method: this.state.shippingMethod,
                    payment:this.state.payment,
                    transaction_id:nonce,
                    tax_id:this.taxIds[this.state.shippingAddress.province]
                },
                shippingAddress:{...this.state.shippingAddress},
                billingAddress:{...this.state.billingAddress},
                isVisitor:serverInfo.customerid === 'visitors' ? true:false,
                isSameAddress: this.state.isSameAddress,
                uid: this.state.uid
            }
            this.props.navigate('/acer/order/placed',{state:{...this.props.location.state,orderData:data,billingAddress:this.state.billingAddress,shippingAddress:this.state.shippingAddress,isFirstTime:true},replace:true})
        // }
        // else if(this.state.cartItemsNumber === 0){
        //     alert('There is no item in your cart needs to check out.')
        // }else if(!this.state.purchaseOrder){
        //     alert('Purchase order number is mandatory, the length should be 1 - 50 characters and cannot be 0.')
        // }else{
        //     alert('please make sure you have select your shipping and billing address.')
        // }
    }
    
    chooseShipping = (method,rate)=>{
        const shippingTax = this.state.shippingAddress.province ? rate * this.taxes[this.state.shippingAddress.province] * 0.01 : 0
        const grandTotal = this.state.cartItemsSubtotal + this.state.tax + rate + shippingTax
        this.setState({shippingMethod:method,shippingRate:rate,grandTotal:grandTotal, shippingTax})
        PubSub.publish('grandTotal',grandTotal)
        userInfo.updateInfo('grandTotal',grandTotal)
    }
    changeEmail= (e,field)=>{
        const newValue = e.target.value
        console.log(field,newValue)
        let email = this.state.email, confirmEmail = this.state.confirmEmail

        // 使用正则表达式来确保只有数字被输入
        // const numericRegex = /^[0-9]*$/;
        // const newValueIsNumeric = numericRegex.test(newValue);
        if(newValue.length<=100){
            email = field ==='email' ? newValue : email
            confirmEmail = field ==='confirmEmail' ? newValue : confirmEmail
   
        }else{
            email = field ==='email' ? newValue?.substring(0,100) : email
            confirmEmail = field ==='confirmEmail' ? newValue?.substring(0,100) : confirmEmail
        }
        this.setState({
            email,
            confirmEmail
        })
        // const stock = this.state.condition === 'ScratchDent' ? this.state.itemDetail.scratch_dent_stock : this.state.itemDetail.stock
        // if (newValueIsNumeric) {
        //     const newNumber = Number.parseInt(newValue)
        //     if(Number.isNaN(newNumber)){
        //         this.setState({orderedQuantity:newValue})
        //     }else if(newNumber>0 && newNumber<= stock){
        //         this.setState({orderedQuantity:newNumber})
        //     }else if(newNumber > stock){
        //         this.setState({orderedQuantity:stock})
        //     }
        // }
        // console.log(e.target.value);
    }
    componentDidUpdate(){
        if(this.state.shippingAddress && this.state.shippingMethod){
            // console.log('checkout page updated')
            const result = this.validateAddress(this.state.shippingAddress,this.state.billingAddress)
            for(const field in result.errors){
                if(result.errors[field] !== this.state.errors[field]){
                    this.setState({errors:{...result.errors}})
                    break
                }
            }
        }else{
            userInfo.updateInfo('addressValidation',false)
        }
        
        // if(this.state.shippingAddress?.province && this.state.shippingAddress?.province !== this.shippingAddressProvinceRef.current.value){
        //     this.fillAddress()
        // }
        
    }
    componentDidMount(){
        window.scrollTo({top:0,behavior:"auto"})
        this.cartItemsNumber = PubSub.subscribe('cartItemsNumber',(_,data)=>this.setState({cartItemsNumber:data}))
        this.cartItemsSubtotal = PubSub.subscribe('cartItemsSubtotal',(_,data)=>this.setState({cartItemsSubtotal:data}))
        this.cartItemsWeight = PubSub.subscribe('cartItemsWeight',(_,data)=>this.setState({cartItemsWeight:data}))
        this.addresses = PubSub.subscribe('addresses',(_,data)=>this.setState({addresses:[...data]}))
        this.shippingAddress = PubSub.subscribe('shippingAddress',(_,data)=>{
            // for shipping rates
            // if(data?.zip && this.state.shippingAddress?.zip !== data?.zip){
            //     axios.post(`${serverInfo.baseURL}/shipping/rate`,{weight:this.state.cartItemsWeight,zip:data.zip},{headers:{'customerid':serverInfo.customerid,'authorization':serverInfo.token}}).then(
            //         res=>{
            //             if(res.data.scode === 200){
            //                 this.setState({shippingRates:[...res.data.shippingRates]})
            //                 this.calculateTax(data,res.data.shippingRates)
            //                 console.log(res.data)
            //             }else{
            //                 alert(`[ address selection - ${data.zip} ] ${res.data.smessage}`)
            //             }
            //             this.setState({smessage:res.data.smessage})
            //         },
            //         rej=>console.log(rej)
            //     )
            // }else{
            //     this.calculateTax(data,this.state.shippingRates)
            // }

            // free shipping
            if(data){
                this.calculateTax(data,this.state.shippingRates)
                // const tax = this.state.cartItemsSubtotal * this.taxes[data.province] * 0.01
                // const grandTotal = this.state.cartItemsSubtotal + tax + this.state.shippingRates
                // this.setState({shippingAddress:{...data},billingAddress:this.state.isSameAddress?{...data}:this.state.billingAddress,tax,grandTotal})
            }else{
                this.setState({shippingAddress:data,tax:null,grandTotal:null})
            }
        })
        this.billingAddress = PubSub.subscribe('billingAddress',(_,data)=>this.setState({billingAddress:data?{...data}:data}))
        this.nonceToken = PubSub.subscribe('nonce',(_,data)=>{
            if(data.result){
                serverInfo.updateInfo('isFirstTime',true)
                this.setState({isProcessing:false,paymentError:false})
                this.placeOrder(data.nonce)
                // console.log('checkout page nonce', data)
                // this.setState({isProcessing:false,paymentError:false})
                // this.props.navigate('/order/placed',{state:{...this.props.location.state,orderData:orderInfo,billingAddress:this.state.billingAddress,shippingAddress:this.state.shippingAddress,isFirstTime:true,orderId:this.state.orderId},replace:true})
            }
        })
        if(this.props.location.state){
            const cartItemsWeight = userInfo.cartItems?.reduce((total,current)=>total+(current.weight*current.quantity),0)
            this.setState({
                cartItemsNumber:userInfo.cartItemsNumber,
                cartItemsSubtotal:userInfo.cartItemsSubtotal,
                cartItemsWeight,
                addresses:[...userInfo.addresses]
            })
        }
        PubSub.publish('routes',[
            {pathname:'/acer/cart',name:"Your Cart",isCurrent:false},
            {pathname:'/acer/checkout',name:"Check Out",isCurrent:true}
        ])
    }
    componentWillUnmount(){
        PubSub.unsubscribe(this.cartItemsNumber)
        PubSub.unsubscribe(this.cartItemsSubtotal)
        PubSub.unsubscribe(this.cartItemsWeight)
        PubSub.unsubscribe(this.nonceToken)
        PubSub.unsubscribe(this.addresses)
        PubSub.unsubscribe(this.shippingAddress)
        PubSub.unsubscribe(this.billingAddress)
    }
  render() {

    return (
      <div className='checkoutpage'>
        <PageRoute/>
        <div className='checkoutpage-content'>
            <div className='checkoutpage-navi' style={{display:'none'}}>
                <button className='active'>1. PLACE ORDER</button>
                <button>2. ORDER REVIEW</button>
            </div>
            <div className='checkoutpage-order'>
                <div className='checkoutpage-order-info'>
                    <div className='checkoutpage-address'>
                        <h2>SHIPPING ADDRESS</h2>
                        <div className='checkoutpage-address-content checkout-address'>
                            {this.state.showShippingAddressForm ?'' : this.state.addresses?.map(address=>(<Address width='100%' textColor='black' key={`s-${address.address_id}`} showCheckbox={true} hideButtons={true} address={address} addressType={'shippingAddress'} isChecked={this.state.shippingAddress && this.state.shippingAddress.address_id === address.address_id?true:false} hideAddress={this.state.showShippingAddressForm}/>))}
                            {/* <Link to={{pathname:'/account/addressForm',state:{from:this.props.location.pathname}}}>Add a New Address</Link> */}
                            <div className='accountpage-addressesform' style={{display:(this.state.addresses.length<=0 || this.state.showShippingAddressForm) && !this.state.shippingAddressSelected ?"flex":"none"}}>
                                <form action="">
                                    <div>
                                        <p>
                                            <label className='mandatory'>First Name</label>
                                            <input type='text' ref={this.shippingAddressFirstNameRef} className={this.state.errors.shippingAddressFirstName ? 'error':""} onBlur={()=>this.fillAddress('shippingFirstName')}/>
                                            <label className={this.state.errors.shippingAddressFirstName ? 'error':""}>{this.state.errors.shippingAddressFirstName ? this.state.errors.shippingAddressFirstName:""}</label>
                                        </p>
                                        <p>
                                            <label className='mandatory'>Last Name</label>
                                            <input ref={this.shippingAddressLastNameRef} className={this.state.errors.shippingAddressLastName ? 'error':""} onBlur={()=>this.fillAddress('shippingLastName')}/>
                                            <label className={this.state.errors.shippingAddressLastName ? 'error':""}>{this.state.errors.shippingAddressLastName ? this.state.errors.shippingAddressLastName:""}</label>
                                        </p>
                                    </div>
                                    <div>
                                        <p>
                                            <label>Company Name</label>
                                            <input type='text' ref={this.shippingAddressCompanyRef} className={this.state.errors.shippingAddressCompany ? 'error':""} onBlur={()=>this.fillAddress('shippingCompany')}/>
                                            <label className={this.state.errors.shippingAddressCompany ? 'error':""}>{this.state.errors.shippingAddressCompany ? this.state.errors.shippingAddressCompany:""}</label>
                                        </p>
                                        <p>
                                            <label className='mandatory'>Phone Number</label>
                                            <input type='text' ref={this.shippingAddressPhoneNumberRef} className={this.state.errors.shippingAddressPhoneNumber ? 'error':""} onBlur={()=>this.fillAddress('shippingPhoneNumber')}/>
                                            <label className={this.state.errors.shippingAddressPhoneNumber ? 'error':""}>{this.state.errors.shippingAddressPhoneNumber ? this.state.errors.shippingAddressPhoneNumber:""}</label>
                                        </p>
                                    </div>
                                    <div>
                                        <p>
                                            <label className='mandatory'>Address Line 1</label>
                                            <input type='text'  ref={this.shippingAddressLine1Ref} className={this.state.errors.shippingAddressLine1 ? 'error':""} onBlur={()=>this.fillAddress('shippingLine1')}/>
                                            <label className={this.state.errors.shippingAddressLine1 ? 'error':""}>{this.state.errors.shippingAddressLine1 ? this.state.errors.shippingAddressLine1:""}</label>
                                        </p>
                                        <p>
                                            <label>Address Line 2</label>
                                            <input type='text'  ref={this.shippingAddressLine2Ref} className={this.state.errors.shippingAddressLine ? 'error':""} onBlur={()=>this.fillAddress('shippingLin2')}/>
                                            <label className={this.state.errors.shippingAddressLine ? 'error':""}>{this.state.errors.shippingAddressLine ? this.state.errors.shippingAddressLine:""}</label>
                                        </p>
                                    </div>
                                    <div>
                                        <p>
                                            <label className='mandatory'>Country</label>
                                            <select ref={this.shippingAddressCountryRef} onChange={()=>{this.setState({shippingCountry:this.shippingAddressCountryRef.current.value})}} onBlur={()=>this.fillAddress('shippingAddress')}>
                                                <option>Canada</option>
                                                {/* <option>United States</option> */}
                                            </select>
                                            <label></label>
                                        </p>
                                        <p>
                                            <label className='mandatory'>State/Province</label>
                                                <select 
                                                    ref={this.shippingAddressProvinceRef}
                                                    className={this.state.errors.shippingAddressProvince ? 'error':""}
                                                    onChange={()=>{
                                                        this.setState({shippingProvince:!this.shippingAddressProvinceRef || this.shippingAddressProvinceRef.current.value === 'Choose a State' ? null : this.shippingAddressProvinceRef.current.value})
                                                        PubSub.publish('shippingAddress',{
                                                            first_name: this.shippingAddressFirstNameRef.current.value === '' ? null: this.shippingAddressFirstNameRef.current.value,
                                                            last_name: this.shippingAddressLastNameRef.current.value === '' ? null: this.shippingAddressLastNameRef.current.value,
                                                            company: this.shippingAddressCompanyRef.current.value === '' ? null: this.shippingAddressCompanyRef.current.value,
                                                            phone_number: this.shippingAddressPhoneNumberRef.current.value === '' ? null: this.shippingAddressPhoneNumberRef.current.value,
                                                            address_line_1: this.shippingAddressLine1Ref.current.value === '' ? null: this.shippingAddressLine1Ref.current.value,
                                                            address_line_2: this.shippingAddressLine2Ref.current.value === '' ? null :this.shippingAddressLine2Ref.current.value,
                                                            city: this.shippingAddressCityRef.current.value === '' ? null: this.shippingAddressCityRef.current.value,
                                                            province: this.shippingAddressProvinceRef.current.value === 'Choose a State' ? null : this.shippingAddressProvinceRef.current.value,
                                                            country : this.shippingAddressCountryRef.current.value,
                                                            zip: this.shippingAddressZipRef.current.value === '' ? null: this.shippingAddressZipRef.current.value.replace(/ /g,'')
                                                        })
                                                    }}
                                                    onBlur={()=>this.fillAddress('shippingAddress')}

                                                >
                                                    <option>Choose a State</option>
                                                    {this.province[this.state.shippingCountry]?.map((province)=>(<option key={`shipping-${province}`}>{province}</option>))}
                                                </select>
                                                <label className={this.state.errors.shippingAddressProvince ? 'error':""}>{this.state.errors.shippingAddressProvince ? this.state.errors.shippingAddressProvince:""}</label>
                                        </p>
                                    </div>
                                    <div>
                                        <p>
                                            <label className='mandatory'>Suburb/City</label>
                                            <input type='text'  ref={this.shippingAddressCityRef} className={this.state.errors.shippingAddressCity ? 'error':""} onBlur={()=>this.fillAddress('shppingCity')}/>
                                            <label className={this.state.errors.shippingAddressCity ? 'error':""}>{this.state.errors.shippingAddressCity ? this.state.errors.shippingAddressCity:""}</label>
                                        </p>
                                        <p>
                                            <label className='mandatory'>Zip/Postcode</label>
                                            <input type='text' ref={this.shippingAddressZipRef} className={this.state.errors.shippingAddressZip ? 'error':""} onBlur={()=>this.fillAddress('shippingZip')}/>
                                            <label className={this.state.errors.shippingAddressZip ? 'error':""}>{this.state.errors.shippingAddressZip ? this.state.errors.shippingAddressZip   :""}</label>
                                        </p>
                                    </div>
                                </form>
                            </div>
                            <button className='checkoutpage-address-form-control' style={{display:this.state.addresses.length<=0 || this.state.shippingAddressSelected ? "none" : "flex"}} onClick={()=>this.setState({showShippingAddressForm:!this.state.showShippingAddressForm})}>{this.state.showShippingAddressForm ? 'Hide Form' : 'New Address'}</button>
                        </div>
                        
                    </div>
                    <div className='checkoutpage-address'>
                        <h2 style={{border:"none"}}>BILLING ADDRESS</h2>
                        <label><input type='checkbox' checked={this.state.isSameAddress} onChange={(e)=>this.isSameAddressHandler()}/>Use delivery address as my billing address.</label>
                        <div className='checkoutpage-address-content checkout-address'>
                            {this.state.isSameAddress && this.state.addresses.length > 0 ? 
                            (this.state.billingAddress ? (<Address width='100%' showCheckbox={false} textColor="black" addressType={'billingAddress'} hideButtons={true} isChecked={true} address={this.state.billingAddress}/>): "" ):
                            (this.state.showBillingAddressForm ?'' :this.state.addresses?.map(address=>(<Address width='100%' textColor="black" key={`b-${address.address_id}`} showCheckbox={!this.state.isSameAddress}  addressType={'billingAddress'} hideButtons={true} address={address} isChecked={this.state.billingAddress && this.state.billingAddress.address_id === address.address_id?true:false} hideAddress={this.state.showBillingAddressForm}/>)))}
                            {/* <Address width='100%' showCheckbox={false} /> */}
                            {/* <Link to={{pathname:'/account/addressForm',state:{from:this.props.location.pathname}}} style={{display:"none"}}>Add a New Address</Link> */}
                            <div className='accountpage-addressesform' style={{display:(this.state.addresses.length<=0 || this.state.showBillingAddressForm) && !this.state.isSameAddress ?"flex":"none"}}>
                                <form action="">
                                    <div>
                                        <p>
                                            <label className='mandatory'>First Name</label>
                                            <input type='text' ref={this.billingAddressFirstNameRef} className={this.state.errors.billingAddressFirstName ? 'error':""} onBlur={()=>this.fillAddress('billingFirstName')}/>
                                            <label className={this.state.errors.billingAddressFirstName ? 'error':""}>{this.state.errors.billingAddressFirstName ? this.state.errors.billingAddressFirstName:""}</label>
                                        </p>
                                        <p>
                                            <label className='mandatory'>Last Name</label>
                                            <input ref={this.billingAddressLastNameRef} className={this.state.errors.billingAddressLastName ? 'error':""} onBlur={()=>this.fillAddress('billingLastName')}/>
                                            <label className={this.state.errors.billingAddressLastName ? 'error':""}>{this.state.errors.billingAddressLastName ? this.state.errors.billingAddressLastName:""}</label>
                                        </p>
                                    </div>
                                    <div>
                                        <p>
                                            <label>Company Name</label>
                                            <input type='text'  className={this.state.errors.billingAddressCompany ? 'error':""} ref={this.billingAddressCompanyRef} onBlur={()=>this.fillAddress('billingCompany')}/>
                                            <label className={this.state.errors.billingAddressCompany ? 'error':""}>{this.state.errors.billingAddressCompany ? this.state.errors.billingAddressCompany:""}</label>
                                        </p>
                                        <p>
                                            <label className='mandatory'>Phone Number</label>
                                            <input type='text' ref={this.billingAddressPhoneNumberRef} maxLength='10' className={this.state.errors.billingAddressPhoneNumber ? 'error':""} onBlur={()=>this.fillAddress('billingPhoneNumber')}/>
                                            <label className={this.state.errors.billingAddressPhoneNumber ? 'error':""}>{this.state.errors.billingAddressPhoneNumber ? this.state.errors.billingAddressPhoneNumber:""}</label>
                                        </p>
                                    </div>
                                    <div>
                                        <p>
                                            <label className='mandatory'>Address Line 1</label>
                                            <input type='text'  ref={this.billingAddressLine1Ref} className={this.state.errors.billingAddressLine1 ? 'error':""} onBlur={()=>this.fillAddress('billingLine1')}/>
                                            <label className={this.state.errors.billingAddressLine1 ? 'error':""}>{this.state.errors.billingAddressLine1 ? this.state.errors.billingAddressLine1:""}</label>
                                        </p>
                                        <p>
                                            <label>Address Line 2</label>
                                            <input type='text'  ref={this.billingAddressLine2Ref} className={this.state.errors.billingAddressLine2 ? 'error':""} onBlur={()=>this.fillAddress('billingLine2')}/>
                                            <label className={this.state.errors.billingAddressLine2 ? 'error':""}>{this.state.errors.billingAddressLine2 ? this.state.errors.billingAddressLine2:""}</label>
                                        </p>
                                    </div>
                                    <div>
                                        <p>
                                            <label className='mandatory'>Country</label>
                                            <select ref={this.billingAddressCountryRef} onChange={()=>{
                                                this.fillAddress('billingCountry')
                                                this.setState({billingCountry:this.billingAddressCountryRef.current.value})
                                                }}
                                                onBlur={()=>this.fillAddress('billingCountry')}
                                                >
                                                <option>Canada</option>
                                                {/* <option>United States</option> */}
                                            </select>
                                            <label></label>
                                        </p>
                                        <p>
                                            <label className='mandatory'>State/Province</label>
                                                <select 
                                                className={this.state.errors.billingAddressProvince ? 'error':""}
                                                ref={this.billingAddressProvinceRef}
                                                onChange={()=>this.fillAddress('billingProvince')}
                                                >
                                                    {/* <option>Choose a State</option> */}
                                                    <option>Choose a State</option>
                                                    {this.province[this.state.billingCountry]?.map((province)=>(<option key={`billing-${province}`}>{province}</option>))}
                                                    {/*                                                     
                                                    <option>Ontario</option>
                                                    <option>Quebec</option>
                                                    <option>Nova Scotia</option>
                                                    <option>New Brunswick</option>
                                                    <option>Manitoba</option>
                                                    <option>British Columbia</option>
                                                    <option>Prince Edward Island</option>
                                                    <option>Saskatchewan</option>
                                                    <option>Alberta</option>
                                                    <option>Newfoundland and Labrador</option>
                                                    <option>Northwest Territories</option>
                                                    <option>Yukon</option>
                                                    <option>Nunavut</option> */}
                                                </select>
                                                <label className={this.state.errors.billingAddressProvince ? 'error':""}>{this.state.errors.billingAddressProvince ? this.state.errors.billingAddressProvince:""}</label>
                                        </p>
                                    </div>
                                    <div>
                                        <p>
                                            <label className='mandatory'>Suburb/City</label>
                                            <input type='text'  ref={this.billingAddressCityRef} className={this.state.errors.billingAddressCity ? 'error':""} onBlur={()=>this.fillAddress('billingCity')}/>
                                            <label className={this.state.errors.billingAddressCity ? 'error':""}>{this.state.errors.billingAddressCity ? this.state.errors.billingAddressCity:""}</label>
                                        </p>
                                        <p>
                                            <label className='mandatory'>Zip/Postcode</label>
                                            <input type='text' ref={this.billingAddressZipRef} className={this.state.errors.billingAddressZip ? 'error':""} onBlur={()=>this.fillAddress('billingZip')}/>
                                            <label className={this.state.errors.billingAddressZip ? 'error':""}>{this.state.errors.billingAddressZip ? this.state.errors.billingAddressZip:""}</label>
                                        </p>
                                    </div>
                                </form>
                            </div>
                            <button className='checkoutpage-address-form-control' style={{display:this.state.addresses.length<=0 || this.state.billingAddressSelected || this.state.isSameAddress? "none" : "flex"}} onClick={()=>this.setState({showBillingAddressForm:!this.state.showBillingAddressForm})}>{this.state.showBillingAddressForm ? 'Hide Form' : 'New Address'}</button>
                        </div>
                    </div>
                    <div className='checkoutpage-email' style={{display:serverInfo['customerid'] === 'visitors' ? "flex":"none"}}>
                        <div className='checkoutpage-email-section'>
                            <div>
                                <h2>Email: </h2>
                                <div className='checkoutpage-address-content'>
                                    {/* <input type="text" maxLength={100} value={this.state.email} ref={this.emailRef} onChange={(e)=>this.changeEmail(e,'email')}/> */}
                                    <input type="text" maxLength={100} ref={this.emailRef} onBlur={()=>this.fillAddress('email')}/>
                                </div>
                            </div>
                            <label className={this.state.errors.email ? 'error':""} style={{display:this.state.errors.email ? '':"none"}}>{this.state.errors.email ? this.state.errors.email:""}</label>
                        </div>
                        <div className='checkoutpage-email-section'>
                            <div>
                                <h2>Confirm Email: </h2>
                                <div className='checkoutpage-address-content'>
                                    {/* <input type="text" maxLength={100} value={this.state.confirmEmail} ref={this.confirmEmailRef} onChange={(e)=>this.changeEmail(e,'confirmEmail')}/> */}
                                    <input type="text" maxLength={100} ref={this.confirmEmailRef} onBlur={()=>this.fillAddress('confirmEmail')}/>
                                </div>
                            </div>
                            <label className={this.state.errors.confirmEmail ? 'error':""} style={{display:this.state.errors.confirmEmail ? '':"none"}}>{this.state.errors.confirmEmail ? this.state.errors.confirmEmail:""}</label>
                        </div>
                        
                    </div>
                    <div className='checkoutpage-shipping-methods'>
                        {/* <h2>{this.state.shippingRates.length > 0 ? 'SELECT SHIPPING METHOD' : 'SHIPPING (PLEASE FILL SHIPPING ZIP)'}</h2> */}
                        {
                            // this.state.shippingRates.map(rate=>(
                            //     <div className='checkoutpage-shipping-list' key={`checkoutpage-shipping-list-${rate['service-code']}`}>
                            //         <div className='checkoutpage-shipping-tag' key={`checkoutpage-shipping-tag-${rate['service-code']}`}>
                            //             <input key={`input-${rate['service-code']}`} type='checkbox' checked={this.state.shippingMethod ===`Canada Post - ${rate['service-name']}`?true:false} onChange={()=>this.chooseShipping(`Canada Post - ${rate['service-name']}`,rate['price'])}/>
                            //             <div className='checkoutpage-shipping-info' key={`checkoutpage-shipping-info-${rate['service-code']}`}>
                            //                 <p key={`p-${rate['service-code']}-1`}>Canada Post {rate['service-name']}: ${rate['price'].toFixed(2)}</p>
                            //                 {/* <p>Allow 2-3 business days to ship - Arrives 5-12 business days after it has shipped</p> */}
                            //                 <p key={`p-${rate['service-code']}-2`}>Package will be shipped by using canada post {rate['service-name']}.</p>
                            //             </div>
                            //         </div>
                            //     </div>
                            // ))
                        }


                        <h2>SHIPPING</h2>
                        <div className='checkoutpage-shipping-list'>
                            <div className='checkoutpage-shipping-tag'>
                                <input type='checkbox' checked={this.state.shippingMethod ==='Standard'?true:false} onChange={()=>this.chooseShipping('Standard',0)}/>
                                <div className='checkoutpage-shipping-info'>
                                    <p>Standard</p>
                                    {/* <p>Allow 2-3 business days to ship - Arrives 5-12 business days after it has shipped</p> */}
                                    <p>Free Shipping.</p>
                                </div>
                            </div>
                        </div>
                        
                        {/* <div className='checkoutpage-shipping-list'>
                            <div className='checkoutpage-shipping-tag'>
                                <input type='checkbox' checked={this.state.shippingMethod ==='Standard'?true:false} onChange={()=>this.chooseShipping('Standard')}/>
                                <div className='checkoutpage-shipping-info'>
                                    <p>Standard</p>
                                    <p>Allow 2-3 business days to ship - Arrives 5-12 business days after it has shipped</p>
                                    <p>Shipping fee will be manually calculated and shows in invoice.</p>
                                </div>
                            </div>
                        </div>
                        <div className='checkoutpage-shipping-list'>
                            <div className='checkoutpage-shipping-tag'>
                                <input type='checkbox' checked={this.state.shippingMethod ==='Pick Up'?true:false} onChange={()=>this.chooseShipping('Pick Up')}/>
                                <div className='checkoutpage-shipping-info'>
                                    <p>Pick Up</p>
                                    <p>Pick up order.</p>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
                <div className='checkoutpage-summary'>
                    <h2>ORDER SUMMARY {this.state.cartItemsNumber>1?`(${this.state.cartItemsNumber} items)`:`(${this.state.cartItemsNumber} item)`}</h2>
                    <div className='checkoutpage-summary-detail'>
                        <div>
                            <p>Subtotal:</p>
                            <p>${this.state.cartItemsSubtotal.toFixed(2)}</p>
                        </div>
                        <div>
                            <p>Shipping:</p>
                            <p>{this.state.shippingRate === 0 ? 'Free' : `$${this.state.shippingRate.toFixed(2)}`}</p>
                        </div>
                        <div>
                            <p>Tax:</p>
                            <p>{this.state.tax?`$${(this.state.tax + this.state.shippingTax).toFixed(2)}`:'without address'}</p>
                        </div>
                        <div>
                            <p>Grand Total:</p>
                            <p>{this.state.grandTotal?`$${this.state.grandTotal.toFixed(2)}`:`$${this.state.cartItemsSubtotal.toFixed(2)}`}</p>
                        </div>
                    </div>
                    <div style={{width:"100%",marginTop:"20px"}} >
                        <PayPalScriptProvider options={{clientId:this.clientId,currency:"CAD",intent:"capture",disableFunding: "paylater"}}>
                            <Paypal/>
                        </PayPalScriptProvider>
                    </div>
                    {/* <button className={this.state.cartItemsNumber>0?"":"disabled"} onClick={()=>this.placeOrder()} disabled={this.state.cartItemsNumber>0?false:true}>PLACE ORDER</button> */}
                </div>
            </div>
            <div className='checkoutpage-review'>
            </div>
        </div>
      </div>
    )
  }
}
export default withRouter(CheckOutPage)